import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Iuser } from 'src/app/Interface/Iuser';
import { TokenService } from 'src/app/Services/Token.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  items: any[] = [];
  IsShow = false;

  constructor(public token: TokenService, private router: Router) { }

  user: Iuser = {} as Iuser;
  ngOnInit(): void {

    this.token._userID.subscribe((value) => {
      if (!value || value.authorizationKey.length == 0) {

        this.router.navigate(['/Login']);
        return;
      } else {
        this.IsShow = true;
        this.user = value;
      }
    });
    this.items = [
      { label: 'Home', routerLink: '/', icon: 'pi pi-fw pi-plus' },
      { label: 'Sale', routerLink: 'SaleHomePage', icon: 'pi pi-fw pi-download' },
      { label: 'CRMAI Co-Pilot 🤖', routerLink: 'CRMAI/CoPilot', icon: 'pi pi-fw pi-bolt' },
      { label: 'Sale sách', routerLink: 'NguoiDatSach', icon: 'pi pi-fw pi-download' },
      { label: 'Quản lý Sách', routerLink: 'BookMgr', icon: 'pi pi-fw pi-book' },
      { label: 'Marketing', routerLink: 'MarketingReport', icon: 'pi pi-fw pi-refresh' },
      { label: 'Email AI Nurturing ✨', routerLink: 'AIEmailFollowUp', icon: 'pi pi-fw pi-send' },
      { label: 'CSKH', routerLink: 'CSKHHomaPage', icon: 'pi pi-fw pi-refresh' },
      { label: 'Kế hoạch', routerLink: 'KeHoach', icon: 'pi pi-fw pi-refresh' },
      { label: 'Phân tích', routerLink: 'PhanTich', icon: 'pi pi-fw pi-refresh' },
      { label: 'Dự án', routerLink: 'ProjectAndTask', icon: 'pi pi-fw pi-refresh' },
      { label: 'Học tập', routerLink: 'Hoc-Tap-Noi-Bo', icon: 'pi pi-fw pi-refresh' },
      { label: 'Ngày thi', routerLink: 'NgayThiMgr', icon: 'pi pi-fw pi-calendar' },
      { label: 'Lịch khai giảng', routerLink: 'LichKhaiGiangMgr', icon: 'pi pi-fw pi-calendar-plus' },
    ];

  }

  CheckPermit() {


    this.token._userID.subscribe((value: Iuser) => {


      if (!value || !value.authorizationKey || value.authorizationKey.length == 0) {
        this.router.navigate(['/Login']);
        return;
      }
    });

  }
  Logout() {
    this.IsShow = false;
    this.token.logout();
    this.router.navigate(['/Login']);
  }

}
